<div class="container-fluid">
 <div class="row">
   <div class="col-md-12">
     <div class="card">
       <div class="card-header" style="padding-bottom: 5px !important">
         <div *ngIf="update; else elseBlock1">
           <h5 class="pb-2">تعديل الحملة موجود</h5>
      
           يمكنك تعديل الحملة  فى القائمة 

          
         </div>
         <ng-template #elseBlock1>
           <!-- <h5 class="pb-2">إضافة مهنه جديده</h5> -->
           <h5 class="pb-2">أضف حملة جديدة</h5>
           <span style="font-size: 14px">
            يمكنك إضافة الحملة في قائمة   الحملات
           </span>
         </ng-template>
       </div>
       <div class="card-body">
         <form class="needs-validation" [formGroup]="InsertForm" (ngSubmit)="onSubmit()" novalidate
           [ngClass]="{'was-validated': validated}">
           <div class="form-row">
             <!-- title -->
             <div class="col-12 mb-3">
              <label for="">نشط</label>
              <div>
                    <label class="switch">
                  <input type="checkbox" id="inactive" (change)="inactiveChange()" [checked]="inactive == false"  />
                  <span class="slider round"></span>
                </label>
              </div>
          </div>
             <div class="col-6 mb-3">
               <label for="validationCustom01"><span class="validation-required">*</span> اسم الحملة</label>
               <input class="form-control" id="validationCustom01" type="text" formControlName="title"
                 [tooltip]="fc.title.errors?.required ?  'هذه الحقل مطلوب' : null" required
                 [isDisabled]="!((fc.title.errors?.required && fc.title.touched) || validated)" containerClass=""
                   [class.is-valid]="fc.title.valid && (fc.title.touched)"
                 [class.is-invalid]="fc.title.invalid && (fc.title.touched)" />
             </div>
             <div class="col-6 mb-3">
               <label for="validationCustom01"><span class="validation-required">*</span> وصف الحملة</label>
               <input class="form-control" id="validationCustom01" type="text" formControlName="description"
                
                 [tooltip]="fc.description.errors?.required ?'هذه الحقل مطلوب': null" required
                 [isDisabled]="!((fc.description.errors?.required && fc.description.touched) || validated)" containerClass=""
                 [class.is-valid]="fc.description.valid && (fc.description.touched)"
                 [class.is-invalid]="fc.description.invalid && (fc.description.touched)" />
             </div>
         
<!-- image --><div class="col-12    my-3 d-flex justify-content-center ">
               <img src="{{ imageSrc }}" class="image-style w-25" />
             </div><div class="col-12 my-3 ChangeProfilePhoto-block d-flex justify-content-center">
               <input type="file" formControlName="image" #file id="getFile" style="display: none"
                 (change)=" checkType($event.target.files[0].type)==true ?onFileChange($event): this.fc.image.setValue(null) " />  <button type="button" onclick="document.getElementById('getFile').click()" class="btn">
                 رفع صورة
               </button>
             </div>
            
           </div>

           <ng-template #elseBlock>
             <button class="btn  pull-right" type="submit" [disabled]="!submit">
               حفظ
             </button>
           </ng-template>
           <div *ngIf="update; else elseBlock">
             <button class="btn  pull-right" type="submit" [disabled]="!submit">
              تعديل
             </button>
           </div>
         </form>
       </div>
     </div>
   </div>
 </div>